import {
  ApiCartChangeCartPaymentAddressRequestedAction,
  apiCartChangeCartPaymentAddressFailed,
  apiCartChangeCartPaymentAddressSucceeded
} from '../../../api/cart/changeCartPaymentAddressApi';
import { call, put } from 'typed-redux-saga';
import changeCartPaymentAddressAction, {
  ChangeCartPaymentAddressActionInput,
  ChangeCartPaymentAddressActionResult
} from '@spa/lib/actions/cart/changeCartPaymentAddressAction';

function* changeCartPaymentAddressSaga({
  payload: { actionId: requestedActionId, customOrderType, paymentAddress, parentActionId }
}: ApiCartChangeCartPaymentAddressRequestedAction): Generator {
  try {
    const input: ChangeCartPaymentAddressActionInput = { customOrderType, paymentAddress };
    const { cartId, result }: ChangeCartPaymentAddressActionResult = yield* call(
      changeCartPaymentAddressAction,
      'changeCartPaymentAddressAction',
      input
    );
    yield* put(
      apiCartChangeCartPaymentAddressSucceeded({
        cartId,
        parentActionId,
        requestedActionId,
        result
      })
    );
  } catch {
    yield* put(
      apiCartChangeCartPaymentAddressFailed({
        parentActionId,
        requestedActionId
      })
    );
  }
}

export default changeCartPaymentAddressSaga;
